<template>
  <div :class="question.errorMessage ? 'errorBorder' : ''">
    <div class="text title_text">
      <span>{{ question.num }}、</span>{{ question.title }}
      <span v-if="question.must === 1" class="req">*</span>
    </div>
    <div class="scale-div" v-if="question.levels">
      <div v-for="(item, index) in question.levels"
           :key="index" class="level_gradient"
           :style="{
              width: `${(100 - question.levels.length * 2) / question.levels.length}%`,
              background: getGradientColor(index),
              border: `1px solid ${getBorderColor(index)}`
           }
      ">
        {{ item }}
      </div>
    </div>
    <div class="scale-div">
      <div class="scale-rating">
        <el-row v-for="(subQuestionNo,subQuestionIndex) of question.subQuestionCount" :key="subQuestionIndex">
          <div class="scaleTitle">
            <div class="">{{ question.lowTitle[subQuestionIndex] }}</div>
            <div class="">{{ question.highTitle[subQuestionIndex] }}</div>
          </div>
          <ul>
            <li class="td" style="text-align:center;" v-for="(score,colIndex) in arrScore" :key="colIndex">
              <a class="rate-off rate-offlarge" v-if="arrSelected"
                 :class="arrSelected[subQuestionIndex][colIndex]?'rate-on':''"
                 val="score" @click="selectCurrent(subQuestionIndex,colIndex,score,question)">{{ score }}</a>
            </li>
          </ul>
        </el-row>
      </div>
    </div>
    <div class="errorMessage">{{ question.errorMessage }}</div>
  </div>
</template>
<script>
export default {
  props: {
    question: Object
  },
  data() {
    return {
      arrScore: [],
      // arrSelected: [],
      // arrScore: ['1', '2', '3', '4', '5', '6', '7', '8', '9'],
      arrSelected: [
        [false, false, false, false, false, false, false, false, false],
        [false, false, false, false, false, false, false, false, false],
        [false, false, false, false, false, false, false, false, false],
        [false, false, false, false, false, false, false, false, false],
        [false, false, false, false, false, false, false, false, false],
        [false, false, false, false, false, false, false, false, false],
        [false, false, false, false, false, false, false, false, false],
        [false, false, false, false, false, false, false, false, false],
        [false, false, false, false, false, false, false, false, false],
        [false, false, false, false, false, false, false, false, false],
        [false, false, false, false, false, false, false, false, false],
        [false, false, false, false, false, false, false, false, false],
        [false, false, false, false, false, false, false, false, false]
      ],
      arrAnswer: [], //答卷
      result: '',  //结果
      gradientStartColor: [0, 128, 0], // 绿色
      gradientEndColor: [255, 0, 0],   // 红色
      alpha: 0.5,                       // 透明度
      borderAlpha: 0.8                       // 透明度
    }
  },
  created() {
    const question = this.question;
    this.arrScore = question.arrScore
    // 1>-3,2>-3,3>3,4>-3,5>-3,6>-3,7>-3
    let answer = question.answer
    let arrAnswer = answer !== null ? answer.split(',') : []
    for (let subQuestionIndex = 1; subQuestionIndex <= question.subQuestionCount; subQuestionIndex++) {
      if (arrAnswer.length === question.subQuestionCount && arrAnswer[subQuestionIndex - 1].indexOf('>-3') === -1) {
        let arr = arrAnswer[subQuestionIndex - 1].split('>')
        let rowI = Number(arr[0]) - 1
        let colI = Number(arr[1])
        this.arrSelected[rowI][colI - 1] = true;
        this.arrAnswer.push(subQuestionIndex + '>' + colI);    //已经答题状态
      } else {
        this.arrAnswer.push(subQuestionIndex + '>-3');    //未答题状态
      }
    }
    this.result = this.arrAnswer.join(',');
  },
  computed: {
    levelWidth() {
      return `${(100 - this.question.levels.length * 2) / this.question.levels.length}%`;
    }
  },
  methods: {
    selectCurrent: function (subQuestionIndex, colIndex, score, question) {
      let value = [false, false, false, false, false, false, false, false, false];
      value[colIndex] = true;
      this.$set(this.arrSelected, subQuestionIndex, value);
      this.$set(this.arrAnswer, subQuestionIndex, (subQuestionIndex + 1) + '>' + score);
      let answer = this.arrAnswer.join(',');
      this.result = answer
      question.answer = answer
      if (answer.indexOf('>-3') !== -1) {
        question.finish = 0
      } else {
        question.finish = 1
        question.errorMessage = ''
      }
      this.$emit("listenToChildEvent", question.num, this.result, question)
    },
    getGradientColor(index) {
      const green = [0, 255, 0];
      const yellow = [255, 255, 0];
      const red = [255, 0, 0];
      const ratio = index / (this.question.levels.length - 1);
      if (ratio <= 0.5) {
        const color = green.map((value, i) =>
          Math.round(value + ratio * 2 * (yellow[i] - value))
        );
        return `linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0)), rgba(${color.join(",")},0.199)`;
      } else {
        const color = yellow.map((value, i) =>
          Math.round((ratio - 0.5) * 2 * (red[i] - value) + value)
        );
        return `linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0)), rgba(${color.join(",")},0.199)`;
      }
    },
    getBorderColor(index) {
      const green = [0, 255, 0];
      const yellow = [255, 255, 0];
      const red = [255, 0, 0];
      const ratio = index / (this.question.levels.length - 1);
      if (ratio <= 0.5) {
        const color = green.map((value, i) =>
          Math.round(value + ratio * 2 * (yellow[i] - value))
        );
        return `rgba(${color.join(",")}, 0.8)`;
      } else {
        const color = yellow.map((value, i) =>
          Math.round((ratio - 0.5) * 2 * (red[i] - value) + value)
        );
        return `rgba(${color.join(",")}, 0.8)`;
      }
    }
  }
}
</script>
<style scoped>
.scale-div {
  width: 94%;
  background: #fff;
  margin: auto;
  padding: 0.1rem;
}

.scaleTitle {
  display: flex;
  padding: 8px 10px;
  justify-content: space-between;
}

.scale-rating ul {
  display: flex;
  border-top: 1px solid #e3e3e3;
  padding: 10px 0;
}

ul, li {
  list-style: none;
}

.scale-rating li {
  text-align: center;
  width: 20px;
  height: 28px;
  line-height: 28px;
  flex: 1 1 auto;
  display: flex;
  justify-content: center;
  align-items: center;
}

.scale-rating a.rate-offlarge {
  width: 20px;
  height: 20px;
  line-height: 18px;
  font-size: 14px;
  text-align: center;
}

.scale-rating a.rate-off {
  width: 18px;
  height: 18px;
  text-decoration: none;
  border-radius: 30px;
  color: #595959;
  border: 1px solid #a6a6a6;
  cursor: default;
  display: inline-block;
  background: #fff;
  line-height: normal;
  font-size: 14px;
}

.scale-rating a.rate-on {
  background-color: #0095ff;
  border: 1px solid #0095ff;
  position: relative;
  color: #fff;
  font-size: 14px;
}

.req {
  color: red
}

.title_text {
  font-weight: bold;
}

.gradient {
  background: linear-gradient(to left, rgba(0, 128, 0, 0.5), rgba(255, 0, 0, 0.5));
}

.level_gradient {
  float: left;
  margin: 0 1%;
  text-align: center;
  border-radius: 3px;
  color: rgba(0,0,0,0.5);
  font-size: 11px;
}

/* .rate-off {
  width: 21px;
  height: 21px;
  text-decoration: none;
  border-radius: 30px;
  color: #333;
  border: 1px solid #cacece;
  cursor: default;
  display: inline-block;
  background: #fafafa;
  line-height: 19px;
  text-align: center;
}

.rate-on {
  background-color: #53a4f4 !important;
  border: 1px solid #53a4f4;
  position: relative;
  color: #fff;
} */
</style>
<!--
init(){
        for(let score=this.question.lowScore;score<=this.question.highScore;score++){
          this.arrScore.push(score);
        }
        //
        let select = [];
        for(let scoreIndex=0;scoreIndex<this.arrScore.length;scoreIndex++){
          select.push(false);
        }
        for(let subQuestionIndex=0;subQuestionIndex<this.question.subQuestionCount;subQuestionIndex++){
          this.arrSelected.push(select);
          this.arrAnswer.push((subQuestionIndex+1)+'>-3');    //未答题状态
        }
        this.result = this.arrAnswer.join(',');
        // console.log('this.arrSelected/this.result'+this.arrSelected+'/'+this.result);
      },
-->
